<template>
  <div class="h-auto ml-0 p-3 w-full lg:mr-3">
    <!-- <div class="bg-white mx-3 mt-3 rounded-t-md border-b-0.5">
      <div class="flex justify-between items-center p-3">
        <p class="font-semibold lg:text-base text-sm">
          Company Time Off
        </p>
      </div>
    </div> -->

    <el-tabs type="border-card" v-model="selectedSubMenu">
      <el-tab-pane
          v-for="(tab, index) in subMenus"
          :key="index"
          :label="tab.name"
          @click="(e) => setTab(e, tab.name)"
          :name="tab.name"
      >
        <LeaveTypeList v-if="index == 0"></LeaveTypeList>
        <LeaveWorkflow v-if="index == 1"></LeaveWorkflow>
        <LeavePeriods v-if="index == 2"></LeavePeriods>
        <TimeOffJournalsList v-if="index == 3"></TimeOffJournalsList>
        <TimeOffLedgerList v-if="index == 4"></TimeOffLedgerList>
        <TimeOffBaseCalendar v-if="index == 5"></TimeOffBaseCalendar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LeaveTypeList from "@/components/CompanySetups/leaveTypes/leaveTypeList.vue";
import LeaveWorkflow from "@/components/CompanySetups/leaveWorkflow/LeaveWorkflow.vue";
import LeavePeriods from "@/components/CompanySetups/leavePeriods/leavePeriodsList.vue";
import TimeOffJournalsList from "@/components/CompanySetups/timeOffSetups/timeOffJournalsList.vue";
import TimeOffLedgerList from "@/components/CompanySetups/timeOffSetups/timeOffLedgerEntriesList.vue";
import TimeOffBaseCalendar from "@/components/CompanySetups/timeOffSetups/timeOffBaseCalendar.vue";

export default {
  name: "CompanyTimeOffSetups",
  components: {
    LeaveTypeList,
    LeaveWorkflow,
    LeavePeriods,
    TimeOffJournalsList,
    TimeOffLedgerList,
    TimeOffBaseCalendar,
  },
  data() {
    return {
      selectedSubMenu: "Time off Types", // Default selected tab
      subMenus: [
        { name: "Time off Types", route: "timeoff-types", key: 'tTKey' },
        { name: "Time off Workflows", route: "time-off-workflows", key: 'tWKey' },
        { name: "Time off Periods", route: "timeoff-periods", key: 'tPKey' },
        { name: "Time off Journals", route: "time-off-journals", key: 'tJKey' },
        { name: "Time off Ledgers", route: "time-off-ledgers", key: 'tLKey' },
        { name: "Base Calendar", route: "base-calendar", key: 'bCKey' },
      ],
      tabKeys: {
        tTKey: 0,
        tWKey: 1,
        tPKey: 2,
        tJKey: 3,
        tLKey: 4,
        bCKey: 5
      }
    };
  },
  mounted() {
    this.setInitialTab();
  },
  watch: {
    $route(to) {
      this.updateSelectedSubMenu(to.params.type);
    }
  },
  methods: {

    setInitialTab() {
      if (this.$route.hash === '#time-off-journals') {
        this.selectSubMenu("Time off Journals");
      } else if (this.$route.params.type) {
        this.updateSelectedSubMenu(this.$route.params.type);
      } else {
        this.selectSubMenu("Time off Types"); // Default tab
      }
    },

    updateSelectedSubMenu(type) {
      const matchedMenu = this.subMenus.find(menu => menu.route === type);
      if (matchedMenu) {
        this.selectSubMenu(matchedMenu.name);
      } else {
        this.selectSubMenu("Time off Types"); // Fallback to default tab
      }
    },
    selectSubMenu(menuName) {
      const matchedMenu = this.subMenus.find(menu => menu.name === menuName);
      if (matchedMenu) {
        this.selectedSubMenu = matchedMenu.name;
        this.incrementKey(matchedMenu.key);
        console.log(`Switched to tab: ${this.selectedSubMenu}`);
      }
    },

    /**
     * Increment the tab key to trigger reactivity.
     * @param {String} key - The key to increment.
     */
    incrementKey(key) {
      if (key && Object.prototype.hasOwnProperty.call(this.tabKeys, key)) {
        this.tabKeys[key]++;
      }
    }
  }
};


</script>
